export default "__VITE_ASSET__D7R5b_Hp__"